import { useCallback, useEffect, useRef } from "react";
import { useMutation } from "convex/react";
import { api } from "../../convex/_generated/api";
import type { Id } from "../../convex/_generated/dataModel";

export function useTyping(conversationId: Id<"conversations">) {
  const start = useMutation(api.typing.start);
  const stop = useMutation(api.typing.stop);
  const lastSent = useRef(0);
  const stopTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const ping = useCallback(() => {
    const now = Date.now();
    if (now - lastSent.current > 2000) {
      lastSent.current = now;
      void start({ conversationId });
    }
    if (stopTimer.current) clearTimeout(stopTimer.current);
    stopTimer.current = setTimeout(() => {
      lastSent.current = 0;
      void stop({ conversationId });
    }, 4000);
  }, [conversationId, start, stop]);

  const stopNow = useCallback(() => {
    lastSent.current = 0;
    if (stopTimer.current) clearTimeout(stopTimer.current);
    void stop({ conversationId });
  }, [conversationId, stop]);

  useEffect(() => {
    return () => {
      if (stopTimer.current) clearTimeout(stopTimer.current);
    };
  }, []);

  return { ping, stopNow };
}
